import { Show } from "solid-js";
import HubbleImage from "~/widgets/hubble_image";

export type BrandCardMobileRnrProps = {
  imageUrl: string;
  name: string;
  discountPercentage?: number;
  onClick: () => void;
  forceDarkTheme?: boolean;
};

export function BrandCardMobileRnr(props: BrandCardMobileRnrProps) {
  const hasDiscount = () => (props.discountPercentage ?? 0) > 0;

  return (
    <div
      class="flex cursor-pointer flex-col gap-2"
      classList={{
        "telescope-dark-theme": props.forceDarkTheme,
      }}
      onClick={props.onClick}
    >
      {/* Image Container */}
      <div class="relative aspect-[117/131] w-full shrink-0 overflow-hidden rounded-xl">
        <HubbleImage
          src={props.imageUrl}
          alt={props.name}
          class="absolute inset-0 size-full object-cover"
        />
      </div>

      {/* Brand Info */}
      <div class="flex w-full flex-col items-start px-1">
        {/* Brand Name */}
        <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap text-[10px] font-medium uppercase leading-3 tracking-[0.4px] text-text-normal-primary">
          {props.name}
        </div>

        {/* Discount Info */}
        <Show when={hasDiscount()}>
          <div class="flex items-end">
            <span class="text-title-4-semi-bold text-success-base">
              {props.discountPercentage}
            </span>
            <span class="mb-[2px] text-para-3-bold text-success-base">
              % off
            </span>
          </div>
        </Show>
      </div>
    </div>
  );
}
